


import React, { useState, useEffect } from 'react';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';

const flightResults = [
  {
    airline: 'IndiGo',
    code: '6E-204',
    dep: '06:10',
    arr: '08:05',
    depCity: 'HYD',
    arrCity: 'BOM',
    duration: '1h 55m',
    stops: 'Non-stop',
    baggage: '15 KG',
    price: '₹4,299',
    class: 'Economy',
  },
  {
    airline: 'Air India',
    code: 'AI-542',
    dep: '08:30',
    arr: '10:25',
    depCity: 'HYD',
    arrCity: 'BOM',
    duration: '1h 55m',
    stops: 'Non-stop',
    baggage: '25 KG',
    price: '₹5,499',
    class: 'Economy',
    badge: 'Best Value',
  },
  {
    airline: 'Vistara',
    code: 'UK-877',
    dep: '11:45',
    arr: '13:40',
    depCity: 'HYD',
    arrCity: 'BOM',
    duration: '1h 55m',
    stops: 'Non-stop',
    baggage: '20 KG',
    price: '₹6,150',
    class: 'Economy',
  },
  {
    airline: 'Air India',
    code: 'AI-883',
    dep: '14:20',
    arr: '19:55',
    depCity: 'HYD',
    arrCity: 'BOM',
    duration: '5h 35m',
    stops: '1 Stop (DEL)',
    baggage: '25 KG',
    price: '₹3,899',
    class: 'Economy',
  },
  {
    airline: 'IndiGo',
    code: '6E-5396',
    dep: '18:55',
    arr: '20:55',
    depCity: 'HYD',
    arrCity: 'BOM',
    duration: '2h 00m',
    stops: 'Non-stop',
    baggage: '15 KG',
    price: '₹5,099',
    class: 'Economy',
  },
];

const popularRoutes = [
  'HYD → BOM', 'HYD → DEL', 'DEL → BOM', 'BOM → GOI',
  'MAA → DEL', 'BLR → CCU', 'HYD → BLR', 'BOM → BLR',
];

export default function Flights() {
  const [from, setFrom] = useState('Hyderabad (HYD)');
  const [to, setTo] = useState('Mumbai (BOM)');
  const [searched, setSearched] = useState(true);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [sortBy, setSortBy] = useState('price');
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= 768 : true
  );

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const swap = () => {
    setFrom(to);
    setTo(from);
  };

  const inputStyle = {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    outline: 'none',
    boxSizing: 'border-box',
    background: 'rgba(255,255,255,0.12)',
    border: '1px solid rgba(255,255,255,0.15)',
    color: '#ffffff',
    fontFamily: 'Manrope, sans-serif',
  };

  return (
    <>
      <Nav />
      <div style={{ minHeight: '100vh', background: 'var(--bg, #f8fafc)', fontFamily: 'Manrope, sans-serif' }}>
        {/* Search Header */}
        <div style={{ background: 'var(--navy, #0a192f)', paddingTop: '80px', paddingBottom: '32px' }}>
          <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px', boxSizing: 'border-box' }}>
            <h1
              style={{
                fontSize: '28px',
                fontWeight: 800,
                color: '#ffffff',
                marginBottom: '24px',
                marginTop: 0,
                fontFamily: 'Manrope, sans-serif',
              }}
            >
              Flight Tickets
            </h1>

            {/* Search Form */}
            <div
              style={{
                borderRadius: '16px',
                padding: '20px',
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.12)',
              }}
            >
              <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                {['Round Trip', 'One Way', 'Multi City'].map((t) => (
                  <button
                    key={t}
                    style={{
                      fontSize: '13px',
                      fontWeight: 600,
                      padding: '4px 12px',
                      borderRadius: '9999px',
                      border: 'none',
                      cursor: 'pointer',
                      background: t === 'Round Trip' ? 'var(--gold, #F47B20)' : 'rgba(255,255,255,0.1)',
                      color: t === 'Round Trip' ? 'var(--navy, #0a192f)' : 'rgba(255,255,255,0.7)',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    {t}
                  </button>
                ))}
              </div>

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: isDesktop ? '2fr 2fr 1.5fr 1.5fr' : 'repeat(2, 1fr)',
                  gap: '12px',
                }}
              >
                <div style={{ position: 'relative', gridColumn: !isDesktop ? 'span 2' : 'auto' }}>
                  <label style={{ display: 'block', fontSize: '11px', fontWeight: 600, marginBottom: '4px', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.05em', fontFamily: 'Manrope, sans-serif' }}>
                    From
                  </label>
                  <input
                    value={from}
                    onChange={(e) => setFrom(e.target.value)}
                    style={inputStyle}
                  />
                  {isDesktop && (
                    <button
                      onClick={swap}
                      style={{
                        position: 'absolute',
                        right: '-16px',
                        top: '28px',
                        zIndex: 10,
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: 700,
                        background: 'var(--gold, #F47B20)',
                        color: 'var(--navy, #0a192f)',
                      }}
                    >
                      ⇄
                    </button>
                  )}
                </div>

                <div style={{ gridColumn: !isDesktop ? 'span 2' : 'auto' }}>
                  <label style={{ display: 'block', fontSize: '11px', fontWeight: 600, marginBottom: '4px', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.05em', fontFamily: 'Manrope, sans-serif' }}>
                    To
                  </label>
                  <input
                    value={to}
                    onChange={(e) => setTo(e.target.value)}
                    style={inputStyle}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '11px', fontWeight: 600, marginBottom: '4px', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.05em', fontFamily: 'Manrope, sans-serif' }}>
                    Departure
                  </label>
                  <input type="date" defaultValue="2026-09-15" style={inputStyle} />
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <button
                    onClick={() => setSearched(true)}
                    style={{
                      width: '100%',
                      padding: '10px 0',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: 700,
                      border: 'none',
                      cursor: 'pointer',
                      background: 'var(--gold, #F47B20)',
                      color: 'var(--navy, #0a192f)',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    Search Flights
                  </button>
                </div>
              </div>

              {/* Popular Routes */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '16px', alignItems: 'center' }}>
                <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)', marginRight: '4px' }}>Popular:</span>
                {popularRoutes.map((r) => (
                  <button
                    key={r}
                    style={{
                      fontSize: '11px',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      color: 'rgba(255,255,255,0.6)',
                      cursor: 'pointer',
                      background: 'rgba(255,255,255,0.07)',
                      border: '1px solid rgba(255,255,255,0.1)',
                    }}
                  >
                    {r}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {searched && (
          <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '32px 24px', boxSizing: 'border-box' }}>
            {/* Results Header */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '16px',
                flexWrap: 'wrap',
                gap: '12px',
              }}
            >
              <div>
                <h2
                  style={{
                    fontSize: '20px',
                    fontWeight: 700,
                    margin: 0,
                    fontFamily: 'Manrope, sans-serif',
                    color: 'var(--navy, #0a192f)',
                  }}
                >
                  HYD → BOM · 15 Sep 2026 · 2 Adults
                </h2>
                <p style={{ fontSize: '13px', marginTop: '2px', marginBottom: 0, color: 'var(--text-muted, #718096)' }}>
                  {flightResults.length} flights found
                </p>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '13px', color: 'var(--text-muted, #718096)' }}>Sort by:</span>
                {['price', 'duration', 'departure'].map((s) => (
                  <button
                    key={s}
                    onClick={() => setSortBy(s)}
                    style={{
                      padding: '4px 12px',
                      borderRadius: '9999px',
                      fontSize: '12px',
                      fontWeight: 600,
                      textTransform: 'capitalize',
                      cursor: 'pointer',
                      background: sortBy === s ? 'var(--navy, #0a192f)' : 'var(--white, #ffffff)',
                      color: sortBy === s ? '#ffffff' : 'var(--text-secondary, #4a5568)',
                      border: `1px solid ${sortBy === s ? 'var(--navy, #0a192f)' : 'var(--border, #e2e8f0)'}`,
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isDesktop ? '1fr 3fr' : '1fr',
                gap: '20px',
              }}
            >
              {/* Filters */}
              {isDesktop && (
                <div>
                  <div
                    style={{
                      borderRadius: '12px',
                      padding: '20px',
                      position: 'sticky',
                      top: '80px',
                      background: 'var(--white, #ffffff)',
                      border: '1px solid var(--border, #e2e8f0)',
                      boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                    }}
                  >
                    <h3 style={{ fontWeight: 700, fontSize: '14px', marginBottom: '16px', marginTop: 0, fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)' }}>
                      Filters
                    </h3>
                    {[
                      { label: 'Stops', options: ['Non-stop', '1 Stop', '2+ Stops'] },
                      { label: 'Airline', options: ['IndiGo', 'Air India', 'Vistara', 'SpiceJet'] },
                      { label: 'Departure Time', options: ['Early Morning (0–6)', 'Morning (6–12)', 'Afternoon (12–18)', 'Night (18–24)'] },
                    ].map((group) => (
                      <div key={group.label} style={{ marginBottom: '20px' }}>
                        <p style={{ fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '10px', marginTop: 0, color: 'var(--text-muted, #718096)', fontFamily: 'Manrope, sans-serif' }}>
                          {group.label}
                        </p>
                        {group.options.map((opt) => (
                          <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', cursor: 'pointer' }}>
                            <input type="checkbox" style={{ width: '14px', height: '14px' }} />
                            <span style={{ fontSize: '13px', color: 'var(--text-secondary, #4a5568)' }}>{opt}</span>
                          </label>
                        ))}
                      </div>
                    ))}
                    <div style={{ marginBottom: '16px' }}>
                      <p style={{ fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '8px', marginTop: 0, color: 'var(--text-muted, #718096)', fontFamily: 'Manrope, sans-serif' }}>
                        Price Range
                      </p>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '4px', color: 'var(--text-muted, #718096)' }}>
                        <span>₹3,500</span>
                        <span>₹12,000</span>
                      </div>
                      <input type="range" min={3500} max={12000} defaultValue={8000} style={{ width: '100%' }} />
                    </div>
                    <button
                      style={{
                        width: '100%',
                        padding: '8px 0',
                        borderRadius: '8px',
                        fontSize: '13px',
                        fontWeight: 700,
                        border: 'none',
                        cursor: 'pointer',
                        background: 'var(--gold, #F47B20)',
                        color: 'var(--navy, #0a192f)',
                        fontFamily: 'Manrope, sans-serif',
                      }}
                    >
                      Apply Filters
                    </button>
                  </div>
                </div>
              )}

              {/* Flight Cards */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {flightResults.map((f, i) => (
                  <div
                    key={i}
                    style={{
                      borderRadius: '12px',
                      overflow: 'hidden',
                      background: 'var(--white, #ffffff)',
                      border: selectedFlight === i ? '1.5px solid var(--royal, #0f2744)' : '1px solid var(--border, #e2e8f0)',
                      boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                    }}
                  >
                    <div
                      style={{
                        padding: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        flexWrap: isDesktop ? 'nowrap' : 'wrap',
                      }}
                    >
                      {/* Airline Logo + Info */}
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '11px',
                          fontWeight: 700,
                          flexShrink: 0,
                          background: 'var(--bg, #f8fafc)',
                          border: '1px solid var(--border, #e2e8f0)',
                          color: 'var(--navy, #0a192f)',
                          fontFamily: 'Manrope, sans-serif',
                        }}
                      >
                        {f.airline.split(' ').map((w) => w[0]).join('')}
                      </div>
                      <div style={{ flexShrink: 0 }}>
                        <p style={{ fontWeight: 700, fontSize: '13px', margin: 0, fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)' }}>
                          {f.airline}
                        </p>
                        <p style={{ fontSize: '11px', margin: 0, color: 'var(--text-muted, #718096)' }}>{f.code}</p>
                      </div>

                      {/* Route Schedule */}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          flex: 1,
                          justifyContent: 'center',
                          minWidth: '220px',
                        }}
                      >
                        <div style={{ textAlign: 'center' }}>
                          <p style={{ fontSize: '20px', fontWeight: 800, margin: 0, fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)' }}>
                            {f.dep}
                          </p>
                          <p style={{ fontSize: '11px', fontWeight: 600, margin: 0, color: 'var(--text-muted, #718096)' }}>{f.depCity}</p>
                        </div>
                        <div style={{ flex: 1, textAlign: 'center', padding: '0 8px' }}>
                          <p style={{ fontSize: '11px', marginBottom: '2px', marginTop: 0, color: 'var(--text-muted, #718096)' }}>{f.duration}</p>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <div style={{ flex: 1, height: '1px', background: 'var(--border, #e2e8f0)' }} />
                            <span style={{ fontSize: '11px' }}>✈</span>
                            <div style={{ flex: 1, height: '1px', background: 'var(--border, #e2e8f0)' }} />
                          </div>
                          <p
                            style={{
                              fontSize: '11px',
                              marginTop: '2px',
                              marginBottom: 0,
                              fontWeight: 600,
                              color: f.stops === 'Non-stop' ? 'var(--success, #16865B)' : 'var(--text-muted, #718096)',
                              fontFamily: 'Manrope, sans-serif',
                            }}
                          >
                            {f.stops}
                          </p>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                          <p style={{ fontSize: '20px', fontWeight: 800, margin: 0, fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)' }}>
                            {f.arr}
                          </p>
                          <p style={{ fontSize: '11px', fontWeight: 600, margin: 0, color: 'var(--text-muted, #718096)' }}>{f.arrCity}</p>
                        </div>
                      </div>

                      {/* Baggage */}
                      {isDesktop && (
                        <div style={{ textAlign: 'center', flexShrink: 0 }}>
                          <p style={{ fontSize: '12px', margin: 0, color: 'var(--text-muted, #718096)' }}>🧳 {f.baggage}</p>
                          <p style={{ fontSize: '11px', margin: 0, color: 'var(--text-muted, #718096)' }}>Check-in</p>
                        </div>
                      )}

                      {/* Price & CTA */}
                      <div style={{ textAlign: 'right', flexShrink: 0, marginLeft: 'auto' }}>
                        {f.badge && (
                          <span
                            style={{
                              display: 'block',
                              fontSize: '10px',
                              fontWeight: 700,
                              marginBottom: '4px',
                              padding: '2px 8px',
                              borderRadius: '9999px',
                              background: 'rgba(22,134,91,0.12)',
                              color: 'var(--success, #16865B)',
                              fontFamily: 'Manrope, sans-serif',
                            }}
                          >
                            {f.badge}
                          </span>
                        )}
                        <p
                          style={{
                            fontSize: '20px',
                            fontWeight: 800,
                            margin: 0,
                            fontFamily: 'Manrope, sans-serif',
                            color: 'var(--navy, #0a192f)',
                          }}
                        >
                          {f.price}
                        </p>
                        <p style={{ fontSize: '11px', marginBottom: '8px', marginTop: 0, color: 'var(--text-muted, #718096)' }}>per person</p>
                        <button
                          onClick={() => setSelectedFlight(selectedFlight === i ? null : i)}
                          style={{
                            padding: '8px 16px',
                            borderRadius: '8px',
                            fontSize: '13px',
                            fontWeight: 700,
                            border: 'none',
                            cursor: 'pointer',
                            background: 'var(--gold, #F47B20)',
                            color: 'var(--navy, #0a192f)',
                            fontFamily: 'Manrope, sans-serif',
                          }}
                        >
                          {selectedFlight === i ? 'Hide Fare' : 'View Fare'}
                        </button>
                      </div>
                    </div>

                    {/* Fare Tiers Drawer */}
                    {selectedFlight === i && (
                      <div
                        style={{
                          padding: '16px',
                          borderTop: '1px solid var(--border, #e2e8f0)',
                        }}
                      >
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: isDesktop ? 'repeat(3, 1fr)' : '1fr',
                            gap: '16px',
                          }}
                        >
                          {[
                            { label: 'Saver', price: f.price, features: ['Seat: Chargeable', 'Meals: Chargeable', '1 Check-in bag', 'No date change'] },
                            { label: 'Flex', price: `₹${parseInt(f.price.replace(/[₹,]/g, '')) + 1200}`, features: ['Seat: Included', 'Meals: Chargeable', '1 Check-in bag', 'Date change ₹1500'], highlight: true },
                            { label: 'Premium', price: `₹${parseInt(f.price.replace(/[₹,]/g, '')) + 2800}`, features: ['Seat: Included', 'Meals: Included', '2 Check-in bags', 'Free date change'] },
                          ].map((fare) => (
                            <div
                              key={fare.label}
                              style={{
                                padding: '16px',
                                borderRadius: '12px',
                                border: fare.highlight ? '2px solid var(--royal, #0f2744)' : '1px solid var(--border, #e2e8f0)',
                                background: fare.highlight ? 'rgba(244,123,32,0.04)' : 'var(--bg, #f8fafc)',
                              }}
                            >
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                                <p style={{ fontWeight: 700, fontSize: '14px', margin: 0, fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)' }}>
                                  {fare.label}
                                </p>
                                {fare.highlight && (
                                  <span style={{ fontSize: '10px', fontWeight: 700, padding: '2px 8px', borderRadius: '4px', background: 'var(--royal, #0f2744)', color: '#ffffff', fontFamily: 'Manrope, sans-serif' }}>
                                    Popular
                                  </span>
                                )}
                              </div>
                              <p style={{ fontSize: '18px', fontWeight: 800, marginBottom: '12px', marginTop: 0, fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)' }}>
                                {fare.price}
                              </p>
                              {fare.features.map((feat) => (
                                <p key={feat} style={{ fontSize: '12px', marginBottom: '4px', marginTop: 0, color: 'var(--text-secondary, #4a5568)' }}>
                                  ✓ {feat}
                                </p>
                              ))}
                              <button
                                style={{
                                  width: '100%',
                                  marginTop: '12px',
                                  padding: '8px 0',
                                  borderRadius: '8px',
                                  fontSize: '13px',
                                  fontWeight: 700,
                                  cursor: 'pointer',
                                  background: fare.highlight ? 'var(--royal, #0f2744)' : 'transparent',
                                  color: fare.highlight ? '#ffffff' : 'var(--navy, #0a192f)',
                                  border: fare.highlight ? 'none' : '1.5px solid var(--navy, #0a192f)',
                                  fontFamily: 'Manrope, sans-serif',
                                }}
                              >
                                Select
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}

                {/* Expert Assistance Banner */}
                <div
                  style={{
                    borderRadius: '12px',
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    background: 'var(--navy, #0a192f)',
                    border: '1px solid rgba(244,123,32,0.2)',
                    flexWrap: isDesktop ? 'nowrap' : 'wrap',
                  }}
                >
                  <span style={{ fontSize: '30px' }}>👨‍💼</span>
                  <div style={{ flex: 1 }}>
                    <p style={{ fontWeight: 700, color: '#ffffff', fontSize: '14px', margin: 0, fontFamily: 'Manrope, sans-serif' }}>
                      Need help choosing a flight?
                    </p>
                    <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)', marginTop: '2px', marginBottom: 0 }}>
                      Our travel experts can find better fares and arrange group bookings.
                    </p>
                  </div>
                  <button
                    style={{
                      padding: '8px 16px',
                      borderRadius: '8px',
                      fontSize: '13px',
                      fontWeight: 700,
                      flexShrink: 0,
                      border: 'none',
                      cursor: 'pointer',
                      background: 'var(--gold, #F47B20)',
                      color: 'var(--navy, #0a192f)',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    Get Expert Assistance
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}